import React from 'react';

const withCategoryFilterAutoExpansion = (WrappedComponent) => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        open: {},
      };
    }

    findParentCategories = (categoryId, sfCategories) => {
      if (!categoryId || !sfCategories) return [];

      const parentIds = [];
      let currentId = categoryId;

      while (currentId) {
        const category = sfCategories.find(
          (cat) => String(cat.id) === String(currentId)
        );
        if (!category || !category.parentId) break;

        parentIds.push(category.parentId);
        currentId = category.parentId;
      }

      return parentIds;
    };

    openParentCategories = (currentCategory, sfCategories) => {
      if (!currentCategory || !sfCategories) return {};

      const parentIds = this.findParentCategories(
        currentCategory.id,
        sfCategories
      );
      const openState = {};

      // Add current category to open state
      openState[currentCategory.id] = true;

      // Add all parent categories to open state
      parentIds.forEach((parentId) => {
        openState[parentId] = true;
      });

      return openState;
    };

    openParentCategoriesForSelected = (selectedSfCategories, sfCategories) => {
      if (
        !selectedSfCategories ||
        !sfCategories ||
        selectedSfCategories.length === 0
      )
        return {};

      const openState = {};

      selectedSfCategories.forEach((selectedCategoryId) => {
        const selectedCategory = sfCategories.find(
          (cat) => String(cat.id) === String(selectedCategoryId)
        );
        if (selectedCategory) {
          openState[selectedCategory.id] = true;

          const parentIds = this.findParentCategories(
            selectedCategory.id,
            sfCategories
          );
          parentIds.forEach((parentId) => {
            openState[parentId] = true;
          });
        }
      });

      return openState;
    };

    updateOpenState = (currentCategory, selectedSfCategories, sfCategories) => {
      if (currentCategory && sfCategories) {
        // If there's a current category, open its parent chain
        const parentOpenState = this.openParentCategories(
          currentCategory,
          sfCategories
        );
        this.setState((prevState) => ({
          open: {
            ...prevState.open,
            ...parentOpenState,
          },
        }));
      } else if (selectedSfCategories && sfCategories) {
        // If no current category but there are selected categories, open their parent chains
        const selectedOpenState = this.openParentCategoriesForSelected(
          selectedSfCategories,
          sfCategories
        );
        this.setState((prevState) => ({
          open: {
            ...prevState.open,
            ...selectedOpenState,
          },
        }));
      }
    };

    updateOpenStateWithCurrentCategory = (
      currentCategory,
      selectedSfCategories,
      sfCategories
    ) => {
      if (currentCategory && sfCategories) {
        // If there's a current category, open its parent chain
        const parentOpenState = this.openParentCategories(
          currentCategory,
          sfCategories
        );
        this.setState((prevState) => ({
          currentCategory,
          open: {
            ...prevState.open,
            ...parentOpenState,
          },
        }));
      } else if (selectedSfCategories && sfCategories) {
        // If no current category but there are selected categories, open their parent chains
        const selectedOpenState = this.openParentCategoriesForSelected(
          selectedSfCategories,
          sfCategories
        );
        this.setState((prevState) => ({
          currentCategory,
          open: {
            ...prevState.open,
            ...selectedOpenState,
          },
        }));
      } else {
        this.setState({ currentCategory });
      }
    };

    toggleOpen = (category) => {
      this.setState({
        open: {
          ...this.state.open,
          [category.id]: !(this.state.open[category.id] || false),
        },
      });
    };

    componentDidMount() {
      const { currentCategory, sfCategories, selectedSfCategories } =
        this.props;
      this.updateOpenState(currentCategory, selectedSfCategories, sfCategories);
    }

    componentDidUpdate(prevProps) {
      const { currentCategory, sfCategories, selectedSfCategories } =
        this.props;

      if (
        currentCategory !== prevProps.currentCategory ||
        sfCategories !== prevProps.sfCategories ||
        selectedSfCategories !== prevProps.selectedSfCategories
      ) {
        this.updateOpenStateWithCurrentCategory(
          currentCategory,
          selectedSfCategories,
          sfCategories
        );
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          open={this.state.open}
          toggleOpen={this.toggleOpen}
          currentCategory={
            this.state.currentCategory || this.props.currentCategory
          }
        />
      );
    }
  };
};

export default withCategoryFilterAutoExpansion;
